import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';

const messageStyles = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.fontSizes.smallest,
  fontWeight: 500,
});

type ReportMessageProps = ComponentProps<typeof Typography> & {
  message: string;
};

const ReportMessage = ({ message, sx, ...props }: ReportMessageProps) => {
  return (
    <Typography sx={combineSx(messageStyles, sx)} data-id='asset-report-message' {...props}>
      {message}
    </Typography>
  );
};

export { ReportMessage };
